import {
  SteppedNumberField,
  PriceField,
  InputSelectControlField,
  TextInputField,
  Box,
  Flex
} from '@sequencehq/core-components'
import { usePackagedPriceForm } from './usePackagedPriceForm'
import { ReadOnlyDetails } from '../common/ReadOnlyDetails'
import { PricingModelField } from '../common/PricingModelField'
import { ExternalLedgerForm } from '../common/ExternalLedgerForm/ExternalLedgerForm'
import { Currency } from '@sequencehq/api'
import {
  ShowAdditionalFieldsToggle,
  useShowAdditionalFields
} from '../common/ShowAdditionalFieldsToggle'
import { ListPriceField } from '../common/ListPriceField'
import { UsageMetricParameterFields } from '../common/UsageMetrics/UsageMetricParameterFields'
import { BillingFrequencyField } from '../common/BillingFrequencyField'
import { UsageMetricSelect } from 'UsageMetrics/index'

export const PackagedPriceVariantForm = () => {
  const { fieldsConfig, currency, priceDetails } = usePackagedPriceForm()
  const { showAdditionalFields } = useShowAdditionalFields()

  return (
    <Flex direction="column" gap="16px">
      <ListPriceField />
      <ReadOnlyDetails>
        {priceDetails.map(({ label, value }) => (
          <ReadOnlyDetails.Item key={label} label={label} value={value} />
        ))}
      </ReadOnlyDetails>

      <TextInputField
        label="Display name (appears on invoice)"
        data-testid="packaged.name"
        value={fieldsConfig.name.value}
        onChange={e => fieldsConfig.name.onChange(e.target.value)}
        validationErrors={fieldsConfig.name.validationErrors}
        isDisabled={fieldsConfig.name.disabled}
        placeholder="Enter a display name"
      />

      <Flex alignItems="flex-start" gap="4px">
        <PriceField
          label="Price per package"
          data-testid="packaged.pricePerPackage"
          validationErrors={fieldsConfig.pricePerPackage.validationErrors}
          value={fieldsConfig.pricePerPackage.value}
          onChange={fieldsConfig.pricePerPackage.onChange}
          isDisabled={fieldsConfig.pricePerPackage.disabled}
          currency={currency}
          borderTopRightRadius={0}
          borderBottomRightRadius={0}
          variant="v2"
        />
        {!fieldsConfig.currency.hidden && (
          <Box mt={6}>
            <InputSelectControlField
              data-testid="packaged.currency"
              value={fieldsConfig.currency.value}
              onChange={newCurrency =>
                fieldsConfig.currency.onChange(newCurrency as Currency)
              }
              options={fieldsConfig.currency.options}
              validationErrors={fieldsConfig.currency.validationErrors}
              disabled={fieldsConfig.currency.disabled}
              placeholder="Select currency"
              width="150px"
            />
          </Box>
        )}
      </Flex>
      <SteppedNumberField
        label="Package size"
        validationErrors={fieldsConfig.packageSize.validationErrors}
        precision={0}
        value={fieldsConfig.packageSize.value}
        onChange={fieldsConfig.packageSize.onChange}
        isDisabled={fieldsConfig.packageSize.disabled}
        data-testid="packaged.packageSize"
      />

      <ShowAdditionalFieldsToggle />
      <Flex
        width="100%"
        display={!showAdditionalFields ? 'none' : 'flex'}
        flexDirection="column"
        gap="16px"
      >
        <PricingModelField />

        <BillingFrequencyField
          data-testid="packaged.billingFrequency"
          value={fieldsConfig.billingFrequency.value}
          options={fieldsConfig.billingFrequency.options}
          onChange={fieldsConfig.billingFrequency.onChange}
          validationErrors={fieldsConfig.billingFrequency.validationErrors}
          isDisabled={fieldsConfig.billingFrequency.disabled}
        />

        <UsageMetricSelect
          validationErrors={fieldsConfig.usageMetricId.validationErrors}
          value={fieldsConfig.usageMetricId.value}
          onChange={fieldsConfig.usageMetricId.onChange}
          isDisabled={fieldsConfig.usageMetricId.disabled}
          data-testid="packaged.usageMetric"
        />

        <UsageMetricParameterFields
          fieldsConfig={fieldsConfig}
          usageMetricId={fieldsConfig.usageMetricId.value}
        ></UsageMetricParameterFields>
        <ExternalLedgerForm />
      </Flex>
    </Flex>
  )
}
